// extracted by mini-css-extract-plugin
export default {"inner":"Agreement_inner__WwxEW","title":"Agreement_title__VfApo","text":"Agreement_text__Eu9AP"};